var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStoreSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3877 12.0424C18.3988 11.1745 18.6294 10.3234 19.0579 9.56852C19.4863 8.81361 20.0988 8.17934 20.8382 7.72472C20.3685 7.05382 19.7488 6.5017 19.0283 6.1122C18.3078 5.72271 17.5065 5.50657 16.6878 5.48096C14.9416 5.29766 13.2487 6.52588 12.3588 6.52588C11.4518 6.52588 10.0817 5.49916 8.60638 5.52951C7.65209 5.56034 6.72207 5.83784 5.90691 6.33497C5.09176 6.8321 4.41929 7.53191 3.95501 8.36621C1.9439 11.8482 3.44401 16.9656 5.37052 19.7802C6.3344 21.1584 7.46089 22.698 8.9349 22.6434C10.3773 22.5835 10.916 21.7236 12.6571 21.7236C14.382 21.7236 14.8874 22.6434 16.3914 22.6087C17.9391 22.5835 18.9143 21.2243 19.8444 19.833C20.5369 18.851 21.0698 17.7656 21.4234 16.6171C20.5242 16.2368 19.7568 15.6002 19.217 14.7867C18.6771 13.9732 18.3887 13.0188 18.3877 12.0424Z",
    fill: "#B2B6C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.547 3.62989C16.3909 2.61682 16.8066 1.31468 16.706 0C15.4167 0.135415 14.2257 0.751614 13.3704 1.72582C12.9522 2.20174 12.6319 2.75542 12.4279 3.35521C12.2238 3.95499 12.1399 4.58911 12.1811 5.22132C12.826 5.22796 13.4639 5.08818 14.047 4.81252C14.63 4.53686 15.1429 4.1325 15.547 3.62989Z",
    fill: "#B2B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreSmall);
export default __webpack_public_path__ + "static/media/appStoreSmall.e13c1a052aff53acff2a023a104dc428.svg";
export { ForwardRef as ReactComponent };